import React, { createContext, useContext } from 'react';
import useAwsIpHook from '../../../hooks/Dashboard/aws/useIp';

export const AwsIpContext = createContext();

export const AwsIpProvider = ({ children }) => {
  const data = useAwsIpHook(); // Import everything from the hook

  return (
    <AwsIpContext.Provider value={data}>
      {children}
    </AwsIpContext.Provider>
  );
};

export const useAwsIp = () => useContext(AwsIpContext);